import React from 'react';
import PlayersRosterTable from "./components/PlayersRosterTable";
import { useReactAppState } from "../shared/containers/utils";

function PlayersRosterComposition({ options }) {
  const { t } = useReactAppState();
  let rosterData = options?.playersData ? options?.playersData : [];

  if (rosterData?.length && options?.filterType) {
    const filterType = options?.filterType;
    rosterData = rosterData
      .map((playerData) => {
        if (playerData.playerSlug && options?.linkRulePath) {
          playerData.playerUrl = options.linkRulePath.replace("{slug}", playerData.playerSlug);
        } else {
          playerData.playerUrl = null;
        }

        return playerData;
      })
      .filter((player) => player?.playerCategories.includes(filterType) || player?.rosterCategory === filterType || player?.playerStatusList.includes(filterType));
  }

  return (
    rosterData?.length ?
      <>
        {options?.title ?
          <>
            <div className="mls-o-block-header">
              <div className="mls-o-block-header__title">
                {`${t(options?.title)} ${options?.maxSlots ? `(${options?.maxSlots} ${t("max")})` : ""}`}
              </div>
            </div>
            <div className="mls-o-block-header mls-o-block-header--sm">
              <div className="mls-o-block-header__title">
                {`${t(options?.title)} ${options?.maxSlots ? `(${options?.maxSlots} ${t("max")})` : ""}`}
              </div>
            </div>
          </>
          : null
        }
        <div role="region" className="mls-c-players-roster-composition">
          <PlayersRosterTable
            baseClass={"mls-c-players-roster-composition"}
            playersData={rosterData}
            emptyResultsComponent={
              <></>
            }
          />
        </div>
      </> : null
  );
}

// eslint-disable-next-line no-func-assign
PlayersRosterComposition = React.memo(PlayersRosterComposition);

export default PlayersRosterComposition;
